(() => {
  // Voegt automatisch een klein "Bekijk product"-knopje toe naast de prijs
  // van elke accessoire-aanbeveling in de keuzehulp (sa-dashcam-quiz).
  //
  // Belangrijk: dit script raakt de keuzehulp zelf (vragen, advieslogica,
  // add-to-cart) op geen enkele manier aan. Het kijkt alleen naar de HTML
  // die de keuzehulp al zelf rendert en voegt er, puur visueel, een extra
  // linkje aan toe — en alleen op een sectie-instantie waar dat expliciet
  // is aangezet via de sectie-instelling "Toon 'Bekijk product'-knopje bij
  // accessoires". Op elke andere plek waar de keuzehulp op de site staat,
  // gebeurt er dus niets.
  if (window.__saQuizAddonViewLinkBound) return;
  window.__saQuizAddonViewLinkBound = true;

  function enhanceAddon(addonEl) {
    if (addonEl.dataset.saViewLinkDone === 'true') return;

    var btn = addonEl.querySelector('[data-quiz-addon-add]');
    if (!btn) return;

    // Heeft deze accessoire geen directe "Toevoegen"-knop (dus de knop zegt
    // al "Bekijk")? Dan doet die bestaande knop al precies waar dit knopje
    // voor bedoeld is, en hoeft er niets bij.
    var canDirectAdd = btn.getAttribute('data-can-direct-add') === 'true';
    var url = btn.getAttribute('data-product-url');
    if (!canDirectAdd || !url) {
      addonEl.dataset.saViewLinkDone = 'true';
      return;
    }

    var priceEl = addonEl.querySelector('.sa-dashcam-quiz__addon-price');
    var side = addonEl.querySelector('.sa-dashcam-quiz__addon-side');
    if (!side) return;

    var link = document.createElement('a');
    link.className = 'sa-dashcam-quiz__addon-view-link';
    link.href = url;
    link.textContent = 'Bekijk product';

    if (priceEl) {
      var row = document.createElement('div');
      row.className = 'sa-dashcam-quiz__addon-price-row';
      priceEl.parentNode.insertBefore(row, priceEl);
      row.appendChild(priceEl);
      row.appendChild(link);
    } else {
      side.insertBefore(link, side.firstChild);
    }

    addonEl.dataset.saViewLinkDone = 'true';
  }

  function sync() {
    document
      .querySelectorAll('.sa-dashcam-quiz[data-show-addon-view-link="true"] .sa-dashcam-quiz__addon')
      .forEach(enhanceAddon);
  }

  function start() {
    sync();
    // De keuzehulp bouwt de accessoire-kaarten dynamisch op (na elk
    // antwoord), dus we kijken via een MutationObserver mee wanneer die
    // HTML verschijnt of verandert.
    var observer = new MutationObserver(sync);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  }
})();